export default __webpack_public_path__ + "static/media/leaf.653546a0.png";